import React from "react"
import PropTypes from "prop-types"
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { oldRoutes } from "router/old-routes"
import { Button, Container } from "reactstrap"
import Avatar from "components/common/Avatar"
import Icon from "components/common/Icon"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { useDispatch, useSelector } from "react-redux"
import { createConversation } from "store/conversations"
import { isGuideSelector } from "store/user"
import { toaster } from "components/common/Toast"

const Header = ({ guide, className }) => {
  const loggedIn = useSelector((store) => store.auth.loggedIn)
  const isGuide = useSelector(isGuideSelector)
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const guideGlobalUrl = `${window.location.origin}/#${pathname}`

  const classes = ["py-20"]
  if (className) classes.push(className)

  const address = []
  if (guide.city) address.push(guide.city)
  if (guide.country) address.push(guide.country)

  const clientMessages = () => {
    dispatch(createConversation({ participant_id: guide.user_id })).then((conversation) =>
      navigate(oldRoutes.clientMessagesPath({}, { conversation_id: conversation.id }))
    )
  }

  return (
    <Container className={classes.join(" ")}>
      <div className="hstack gap-10 flex-wrap flex-sm-nowrap">
        <div className="hstack gap-20 w-100 w-md-auto" style={{ flexGrow: 20 }}>
          <Avatar user={guide} size={78} />
          <div className="my-auto flex-fill">
            <div className="hstack gap-1 mb-3">
              {Array(5)
                .fill(null)
                .map((_, index) => (
                  <Icon key={index} iconName="StarNew" className={+guide.rating >= index + 1 ? "text-primary-second" : "text-gray-light"} />
                ))}
            </div>
            <h1 className="h3 lh-1 fw-medium d-block">{guide.display_name}</h1>
            <p className="hstack gap-2 mt-2 mb-0 fs-6 fw-light lh-1">
              <Icon iconName="Location" className="flex-shrink-0" size={14} />
              <span>{address.join(", ") || "—"}</span>
            </p>
          </div>
        </div>
        <div className="hstack gap-x-10 gap-y-1 flex-wrap flex-grow-1 flex-sm-grow-0" style={{ flexShrink: 20 }}>
          {searchParams.has("back_url") && (
            <Button
              tag={Link}
              to={searchParams.get("back_url")}
              color="light"
              className="d-flex gap-3 justify-content-center py-2 px-20 fw-medium text-nowrap flex-fill d-none d-sm-flex"
            >
              <Icon iconName="ArrowLeft" size={18} block />
              Go Back
            </Button>
          )}
          {isGuide && (
            <CopyToClipboard text={guideGlobalUrl} onCopy={() => toaster.info("Link to the guide is copied to the clipboard")}>
              <Button color="light" className="p-2">
                <Icon iconName="ShareArrow" size={24} block />
              </Button>
            </CopyToClipboard>
          )}
          <Button
            color="primary"
            className="py-2 px-20 text-white-hover flex-fill"
            outline
            disabled={!loggedIn || isGuide}
            onClick={clientMessages}
          >
            Message
          </Button>
        </div>
      </div>
    </Container>
  )
}

Header.propTypes = {
  guide: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    user_id: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
    city: PropTypes.string,
    country: PropTypes.string,
    rating: PropTypes.number.isRequired
  }).isRequired,
  className: PropTypes.string
}

export default Header
